import { EntityTypeInvestmentJurisdictionWithNestedObjectResponse } from '../../../../web-api-client';
import { EntityTypeInvestmentJurisdiction } from '../../models/entity-type-investment-jurisdiction';
import { mapInvestmentJurisdictionFromResponseNested } from '../investment-jurisdiction/map-investment-jurisdiction-from-response-nested';
import { mapTargetEntityTypeFromResponse } from './map-target-entity-type-from-response';

export const mapEntityTypeInvJurisdictionFromResponse = (
  response: EntityTypeInvestmentJurisdictionWithNestedObjectResponse
): EntityTypeInvestmentJurisdiction => ({
  entityTypeInvestmentJurisdictionId:
    response.entityTypeInvestmentJurisdictionId,
  investmentJurisdiction: response.investmentJurisdiction
    ? mapInvestmentJurisdictionFromResponseNested(
        response.investmentJurisdiction
      )
    : undefined,
  targetEntityType: response.targetEntityType
    ? mapTargetEntityTypeFromResponse(response.targetEntityType)
    : undefined,
});
